module.exports = __webpack_public_path__ + "static/img/16.71fa50e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/9/1/1/zh/16.png
// module id = BZim
// module chunks = 0